import { Stack } from '@mui/material';
import ArticleSection from '../components/article-section';
import DownloadSection from '../components/download-section';
import FeaturesSection from '../components/feature-section';
import FooterSection from '../components/footer-section';
import HaistAISection from '../components/haist-ai-section';
import Header from '../components/header';
import MainSection from '../components/main-section';
import PricingSection from '../components/pricing-section';
import useHashScroll from '../hooks/useHashScroll';

const MainPage = () => {
  useHashScroll();

  return (
    <Stack
      spacing={0}
      sx={{
        width: '100%',
      }}
    >
      <Header />
      <MainSection />
      <FeaturesSection />
      <HaistAISection />
      <ArticleSection />
      <PricingSection />
      <DownloadSection />
      <FooterSection />
    </Stack>
  );
};

export default MainPage;
